import type { ReactNode } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface SectionShellProps {
  caption: string;
  icon?: ReactNode;
  iconColor?: string;
  extra?: ReactNode;
  children: ReactNode;
  padded?: boolean;
}

/**
 * Bo'lim qobig'i — analitika tabidagi section header uslubida:
 * Caption + (ixtiyoriy) gradient ikona disk + extra. Pastida content card.
 */
export function SectionShell({
  caption,
  icon,
  iconColor = '#3390ec',
  extra,
  children,
  padded = true,
}: SectionShellProps) {
  return (
    <section style={{ marginBottom: 18 }}>
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 4px',
          marginBottom: 10,
          gap: 8,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0, flex: 1 }}>
          {icon && (
            <div
              style={{
                width: 26,
                height: 26,
                borderRadius: 9,
                background: `linear-gradient(135deg, ${iconColor}14 0%, ${iconColor}28 100%)`,
                border: `1px solid ${iconColor}1f`,
                color: iconColor,
                fontSize: 13,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              {icon}
            </div>
          )}
          <Text
            style={{
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: 0.5,
              textTransform: 'uppercase',
              color: 'var(--bl-text-muted, #6b7280)',
            }}
          >
            {caption}
          </Text>
        </div>
        {extra}
      </header>
      <div
        style={{
          borderRadius: 16,
          background: 'var(--bl-surface, #fff)',
          border: '1px solid var(--bl-divider, rgba(16,24,40,0.06))',
          padding: padded ? '14px 14px' : 0,
          boxShadow: 'var(--bl-shadow-soft, 0 2px 10px rgba(16,24,40,0.04))',
        }}
      >
        {children}
      </div>
    </section>
  );
}
